// extracted by mini-css-extract-plugin
export default {"wrapper":"FinanceInfo_wrapper__o0vjX","companyName":"FinanceInfo_companyName__Z7WcZ","redText":"FinanceInfo_redText__h76vM","greenText":"FinanceInfo_greenText__oQZGO"};